import { Component, Input, OnInit } from '@angular/core';
import { FormControl, ValidationErrors, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { IModalComponent, IModalData } from '@app/interfaces';
import { WrapToasterService } from '@app/services/wrap-toaster-service';
import { PartnerService } from '../../../services/partner.service';

@Component({
	selector: 'app-partner-add-organization-modal',
	templateUrl: './partner-add-organization-modal.component.html',
	styleUrls: ['./partner-add-organization-modal.component.scss'],
})
export class PartnerAddOrganizationModalComponent implements IModalComponent<{}>, OnInit {
	@Input() data: IModalData<{}>;
	isLoading$ = new BehaviorSubject(false);
	orgNameControl: FormControl;

	constructor(private partnerService: PartnerService, private toastService: WrapToasterService) {}

	ngOnInit() {
		this.orgNameControl = new FormControl('', [Validators.required, this.checkInputEmpty]);
	}

	checkInputEmpty(fc: FormControl): ValidationErrors | null {
		const value = fc.value.trim();
		return value.length ? null : { empty: true };
	}

	createOrganization() {
		this.isLoading$.next(true);
		const name = this.orgNameControl.value;
		this.partnerService.addOrganization(name).subscribe({
			next: () => {
				this.isLoading$.next(false);
				this.toastService.showToast('success', 'Success!', 'Organization was successfully created');
				this.closeEvent({ message: 'orgCreated' });
			},
			error: (err) => {
				this.isLoading$.next(false);
				this.toastService.handleRequestFailed(err);
				this.closeEvent();
			},
		});
	}

	closeEvent(e?: {}): void {}
}
